import { IconName } from '@thiememeulenhoff/types';
import { PaletteColor, ThemeColor, Tint } from '@thiememeulenhoff/tokens';

export const ContentMessageTypes = ['info', 'message', 'refresh'] as const;
export type ContentMessageType = (typeof ContentMessageTypes)[number];

export const contentMessageIcons: Record<ContentMessageType, IconName> = {
  info: 'info-solid',
  message: 'message',
  refresh: 'refresh',
};

export const contentMessageColors: Record<
  ContentMessageType,
  PaletteColor | ThemeColor
> = {
  info: 'blue',
  message: 'purple',
  refresh: 'purple',
};

export const contentMessageTints: Record<ContentMessageType, Tint> = {
  info: 500,
  message: 600,
  refresh: 600,
};

export const ContentMessageVariants = ['default', 'inline'] as const;

export type ContentMessageVariant = (typeof ContentMessageVariants)[number];
